import Bullet from 'components/Bullet';
import { HeadButtons, PageHeadContainer } from 'components/PageHead';
import ProfileNavigation from 'components/profileNavigation';
import ProfileLink from 'components/profileNavigation/Link';
import React, { FC, useContext, useMemo } from 'react';
import useSWR from 'swr';
import Mentorship from 'types/Mentorship';
import MentorNotifications from 'types/notifications/MentorNotifications';
import { PageTitle } from '../sign-chart';
import MentorshipManagementButtonsRoutes from './ButtonsRoutes';
import MentorshipManagementRoutes from './Routes';

const Head: FC = () => {
  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Vos mentorats</h1>
      </PageTitle>
      <HeadButtons>
        <MentorshipManagementButtonsRoutes />
      </HeadButtons>
    </PageHeadContainer>
  );
};

type ContextType = {
  mentorships: Mentorship[] | undefined;
  error: unknown | undefined;
};
export const MentorshipManagementContext = React.createContext(
  {} as ContextType,
);
const { Provider } = MentorshipManagementContext;

const MentorshipManagement: FC = ({ children }) => {
  const { data: mentorships, error } =
    useSWR<Mentorship[]>('/mentorship/mentor');

  const value: ContextType = useMemo(
    () => ({
      mentorships,
      error,
    }),
    [mentorships, error],
  );

  return <Provider value={value}>{children}</Provider>;
};

const baseURL = '/mentor/mentorship/management/';
const Navigation: FC = () => {
  const { mentorships } = useContext(MentorshipManagementContext);
  const { data: mentorNotifications } = useSWR<MentorNotifications>(
    '/user/notification/mentor',
  );
  return (
    <ProfileNavigation>
      <ProfileLink to={baseURL + 'mentees/'} activeLink={baseURL + 'mentees'}>
        Mentorés
        {mentorNotifications?.mentorshipNotification && <Bullet />}
      </ProfileLink>
      {mentorships && mentorships[0] && (
        <ProfileLink to={baseURL + 'interviews'}>
          Entretiens programmés{' '}
          {mentorNotifications?.interviewNotification && <Bullet />}
        </ProfileLink>
      )}
    </ProfileNavigation>
  );
};

const Usage: FC = (props) => {
  return (
    <MentorshipManagement {...props}>
      <Head />
      <Navigation />
      <MentorshipManagementRoutes />
    </MentorshipManagement>
  );
};

export default Usage;
